import ExcelJS from "exceljs";
import { saveAs } from "@";
import { danger } from "./alerts.js";

// Function to download data as an Excel file
export const downloadExcel = async (
  data,
  headerMap = {},
  splitDate = null,
  headerText = null,
  fileName = "data",
) => {
  if (data?.length > 0) {
    // Create Excel
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // Headermap addresses from Headermap
    const headers = Object.keys(headerMap);

    // Add the integrated text in the first grade
    if (headerText) {
      worksheet.mergeCells(1, 1, 1, headers.length + 1); // Merging the first row
      const mergedCell = worksheet.getCell(1, 1); // Get the compact cell
      mergedCell.value = headerText;
      mergedCell.alignment = { horizontal: "center", vertical: "middle" }; //Alignment of the text
      worksheet.getRow(1).height = 30;
    }

    // Add addresses in the second row
    const processedHeaders = headers.flatMap((header) =>
      headerMap[header] === splitDate
        ? [`${header}_Date`, `${header}_Time`]
        : header,
    );
    worksheet.addRow(processedHeaders);

    // Set the second row height
    worksheet.getRow(headerText ? 2 : 1).height = 20;

    // Data processing
    data.forEach((item) => {
      const rowData = headers.flatMap((header) => {
        const key = headerMap[header];
        if (key === splitDate && item[key]) {
          const [date, time] = item[key].split(" ");
          return [date, time];
        }
        return Array.isArray(item[key]) ? item[key].join(", ") : item[key];
      });

      // Add row
      const row = worksheet.addRow(rowData);

      // Row
      row.height = 20;
    });

    // Adjust the columns width
    worksheet.columns.forEach((column) => {
      column.width = column.header ? column.header.length + 15 : 15;
    });

    // Export the file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  } else {
    await danger("لا توجد بيانات للتصدير");
  }
};
